import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22 6.355h-2.4c.3-.49.4-.978.4-1.467 0-1.857-1.6-3.421-3.5-3.421-2.3 0-3.7 1.564-4.5 3.03-.8-1.466-2.2-3.03-4.5-3.03C5.6 1.467 4 3.03 4 4.888c0 .489.1.978.4 1.467H2c-.6 0-1 .39-1 .977v4.888c0 .587.4.978 1 .978h1v8.798c0 .587.4.978 1 .978h16c.6 0 1-.392 1-.978v-8.798h1c.6 0 1-.391 1-.978V7.332c0-.586-.4-.977-1-.977m-5.5-2.933c.8 0 1.5.684 1.5 1.466s-.7 1.467-1.5 1.467h-3.2c.5-1.174 1.5-2.933 3.2-2.933M6 4.888c0-.782.7-1.466 1.5-1.466 1.7 0 2.7 1.76 3.2 2.933H7.5c-.8 0-1.5-.685-1.5-1.467M3 8.31h8v2.932H3zm2 4.888h6v7.82H5zm14 7.82h-6v-7.82h6zm2-9.776h-8V8.31h8z"
    }, null, -1)
  ]))]))
}
export default { render: render }